import React, { useState } from 'react';
import './Navbar.css';
import logo from '../../assets/images/logo1.png'; 
import { FaArrowRight } from 'react-icons/fa'; // Icon ke liye

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [result, setResult] = useState(""); // Status message ke liye

  const closeMenu = () => setIsMenuOpen(false);
  
  const openModal = () => {
    setIsModalOpen(true);
    closeMenu();
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setResult("");
  };

  // Web3Forms Submit Function
  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    // TODO: Replace with your actual Web3Forms Access Key
    formData.append("access_key", "68f8c92b-95f6-4539-bca9-456711228405");
    formData.append("subject", "New Brochure Request from Website");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Brochure Sent Successfully!");
      event.target.reset();
      setTimeout(() => {
        closeModal();
      }, 2500);
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <>
      <nav className="sentosa-navbar">
        <div className="nav-wrapper">
          <div className="logo-brand">
            <img src={logo} alt="Sentosa Era" />
          </div>

          <div className={`mobile-toggle ${isMenuOpen ? 'open' : ''}`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <span className="linex"></span>
            <span className="linex"></span>
            <span className="linex"></span>
          </div>

          <div className={`nav-content ${isMenuOpen ? 'show' : ''}`}>
            <ul className="links-list">
              <li><a href="#home" className="active-link" onClick={closeMenu}>Home</a></li>
              <li><a href="#about" onClick={closeMenu}>About</a></li>
              <li><a href="#highlights" onClick={closeMenu}>Key Highlights</a></li>
              <li><a href="#pricing" onClick={closeMenu}>Pricing & Floor Plan</a></li>
              <li><a href="#amenities" onClick={closeMenu}>Amenities</a></li>
              <li><a href="#connectivity" onClick={closeMenu}>Connectivity</a></li>
              <li><a href="#contact" onClick={closeMenu}>Contact Us</a></li>
            </ul>

            <div className="nav-action">
              <button className="request-btn" onClick={openModal}>Request Brochure</button>
            </div>
          </div>
        </div>
      </nav>

      {/* --- BROCHURE MODAL --- */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            
            <div className="modal-content">
              <div className="modal-logo">
                <img src={logo} alt="Logo" />
              </div>
              <h2 className="enquire-title">Enquire Now</h2>
              
              <form className="modal-form" onSubmit={onSubmit}>
                <input type="text" name="first_name" placeholder="First Name" required />
                <input type="text" name="last_name" placeholder="Last Name" required />
                <input type="email" name="email" placeholder="Email Id" required />
                <input type="tel" name="mobile" placeholder="Mobile No." required />
                
                {/* <select name="project" required className="modal-select">
                  <option value="" disabled selected>Select Project</option>
                  <option value="Sentosa Era">Sentosa Era</option>
                  <option value="Sentosa Pride">Sentosa Pride</option>
                </select> */}

                <div className="checkbox-container">
                  <input type="checkbox" id="nav-consent" name="consent" required />
                  <label htmlFor="nav-consent">
                    I hereby authorize to send notification on SMS, Calls, RCS, WhatsApp.
                  </label>
                </div>

                <button type="submit" className="modal-submit-btn">
                  SUBMIT NOW <FaArrowRight style={{marginLeft: '8px'}} />
                </button>
              </form>

              {result && <p className="form-status">{result}</p>}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;